let l = location;
export const DOMAIN    = `${l.host}`;
const PROTOCOL         = "https://"
const POSTFIX          = "api";
const VERSION          = "v1";
const NAMESPACE        = "portal";

// const BASE_URL = `${DOMAIN}/${NAMESPACE}/${POSTFIX}`;
const BASE_URL = `${l.protocol}//${DOMAIN}/${NAMESPACE}/${POSTFIX}/${POSTFIX}`;
const BASE_WS_URL = `wss://${DOMAIN}/${NAMESPACE}/${POSTFIX}`;
const CURRENT_PROFILE = window.gconf.profile;


export default {
  NAMESPACE,
  CURRENT_PROFILE,
  api: {
    DOMAIN,
    BASE_URL,
    BASE_WS_URL
  }
}